module.exports = __webpack_public_path__ + "5ff1eb6c8826e031d1e5a6def20cc871.svg";